import React from "react";
import styles from "./callhistory.module.css";
import ContactRow from "./contactrow";

//좌측 카드: 필터 탭(전체 / 콜백 필요 N / 오늘) + 헤더 없는 연락처 리스트
const ContactsTable : React.FC<any> = (props) => {

    const filters = [
        { key : "all", label : "전체" },
        { key : "callback", label : "콜백 필요" },
        { key : "today", label : "오늘" }
    ];

    return (
        <div className={`${styles.card} ${styles.leftCard}`}>
            <div className={styles.filterBar}>
                {
                    filters.map((f) => (
                        <div
                            key={f.key}
                            className={`${styles.filterPill} ${props.filter === f.key ? styles.filterPillActive : ""}`}
                            onClick={() => props.onFilter(f.key)}
                        >
                            {f.label}
                            {f.key === "callback" && props.callbackCount > 0 ? <span className={styles.filterCount}>{props.callbackCount}</span> : ""}
                        </div>
                    ))
                }
            </div>
            <div className={styles.contactList}>
                {
                    props.contacts.length === 0 ?
                        <div className={styles.emptyList}>{props.loading ? "불러오는 중..." : "표시할 통화가 없습니다"}</div>
                        :
                        props.contacts.map((c : any) => (
                            <ContactRow
                                key={c.phoneNumber}
                                contact={c}
                                selected={c.phoneNumber === props.selectedPhone}
                                now={props.now}
                                onSelect={props.onSelect}
                                onComment={props.onComment}
                            />
                        ))
                }
                {
                    props.total > props.contacts.length ?
                        <div className={styles.moreArea}>
                            <button className={styles.moreBtn} onClick={props.onMore}>더 보기 ({props.contacts.length}/{props.total})</button>
                        </div>
                        :
                        null
                }
            </div>
        </div>
    );
};

export default ContactsTable;
